'use strict';

/**
 *
 * @name: persistentVideo
 *
 */

import DirectiveTemplate from './nn-persistent-video.directive.html';

function PersistentVideoDirective(
  $rootScope,
  $timeout,
  transObject,
  apiLoveService,
  playersAnalytics,
  nnModalsService
) {

  'ngInject';

  return {

    restrict: 'E',
    template: DirectiveTemplate,
    replace: true,
    link: function(scope, element) {

      /**
       *
       * @CONFIG
       *
       */

      var rootWatchers = {};
      $rootScope.noPlayer = true;
      $rootScope.highEnough = false;
      $rootScope.videoHeight = element.find('.additional-wrapper').height() || 576;

      /**
       *
       * @PRIVATE
       *
       */

      var setVideo = function() {

        if (!$rootScope.noPlayer && window.scrollY > $rootScope.videoHeight && !$rootScope.disablePersist) {

          $rootScope.showPersistentVideo = true;
          $rootScope.highEnough = true;
        } else if (!$rootScope.noPlayer && window.scrollY > $rootScope.videoHeight) {

          $rootScope.showPersistentVideo = false;
          $rootScope.highEnough = true;

        } else {

          $rootScope.showPersistentVideo = false;
          $rootScope.highEnough = false;
        }
      };

      var setHighEnough = function() {

        if (!$rootScope.noPlayer && window.scrollY > $rootScope.videoHeight) {

          $rootScope.highEnough = true;

        } else {
          $rootScope.highEnough = false;
        }
      };

      var timeoutCallback = function(marker, callback, time) {

        if (marker) {

          $timeout.cancel(marker);
        }

        if (isNaN(time)) {

          time = 144;
        }

        marker = $timeout(function() {

          callback();
        }, time);
      };

      // need to set the data below, so it is available to all closures
      var goPersistTimeoutMarker;
      var disablePersistWatcherTimeoutMarker;

      var goPersistTimeout = function() {

        return timeoutCallback(goPersistTimeoutMarker, setVideo);
      };

      var disablePersistWatchTimeout = function() {

        return timeoutCallback(disablePersistWatcherTimeoutMarker, setHighEnough);
      };

      var goPersist = function() {

        if (!Modernizr.touch && window.innerWidth > 500 && $rootScope.disablePersist !== true) {
          $(window).on('scroll', goPersistTimeout);
          setVideo();
          var event;

          try {

            event = new Event('playerOrPageSizeChange');
          } catch (e) {

            event = document.createEvent('Event');
            event.initEvent('playerOrPageSizeChange', true, true);
          }

          document.dispatchEvent(event);
        }
      };

      /**
       *
       * @PUBLIC
       *
       */

      scope.close = function() {

        $rootScope.disablePersist = true;
        $rootScope.showPersistentVideo = false;
      };

      scope.onOptionClick = function(option) {

        $rootScope.$broadcast('nowness.openOptionPanel', option);
      };

      scope.love = function() {

        if (!$rootScope.post.isLoved && $rootScope.profile) {

          apiLoveService
            .lovePost($rootScope.post.id)
            .then(function() {

              $rootScope.post.isLoved = true;
            });
        } else if ($rootScope.post.isLoved === true && $rootScope.profile) {

          apiLoveService
            .unlove($rootScope.post.id)
            .then(function() {

              $rootScope.post.isLoved = false;
            });
        } else if (!$rootScope.profile) {

          $rootScope.postToLove = $rootScope.post;
          $rootScope.toBeLoved = true;

          rootWatchers.profile = $rootScope.$watch('profile', function(newVal) {

            if (newVal) {

              apiLoveService
                .lovePost($rootScope.post.id)
                .then(function() {

                  $rootScope.post.isLoved = true;
                }, function() {

                  $rootScope.post.isLoved = true;
                });

              rootWatchers.profile();
            }
          });

          nnModalsService.showModal('login')
        }
      };

      /**
       *
       * @INIT
       *
       */

      goPersist();

      $rootScope.$on('$stateChangeStart', function() {

        $rootScope.noPlayer = true;
      });

      $rootScope.$on('$stateChangeSuccess', function(event, toState) {

        var statesExcluded = [
          'main.member',
          'main.ucp',
          'main.ucp.accountFeed',
          'main.ucp.myLoved',
          'main.ucp.myPlaylists',
          'main.ucp.mySettings',
          'main.ucp.mySettings.profile',
          'main.ucp.mySettings.notifications',
          'main.ucp.mySettings.connections',
          'main.ucp.mySettings.account'
        ];

        if (statesExcluded.indexOf(toState.name) > -1 || $rootScope.post === 'slideshow') {
          $rootScope.disablePersist = true;
        } else {

          $rootScope.disablePersist = false;
          goPersist();

          var disablePersistWatcher = $rootScope.$watch('disablePersist', function(newVal) {

            disablePersistWatcher();

            if (newVal === true) {

              $(window).off('scroll', setVideo);
              $(window).on('scroll', setHighEnough);
            }
          });
        }
      });

      rootWatchers.showPersistentVideo = $rootScope.$watch('showPersistentVideo', function(newVal) {

        if (newVal && !$rootScope.noPlayer) {

          playersAnalytics.pV();
        }
      });

      rootWatchers.disablePersist = $rootScope.$watch('disablePersist', function(newVal) {

        rootWatchers.disablePersist();

        if (newVal === true) {

          $(window).off('scroll', goPersistTimeout);
          $(window).on('scroll', disablePersistWatchTimeout);
        }
      });

      rootWatchers.highEnough = $rootScope.$watch('highEnough', function() {

        var event;

        try {

          event = new Event('playerOrPageSizeChange');
        } catch (e) {

          event = document.createEvent('Event');
          event.initEvent('playerOrPageSizeChange', true, true);
        }

        document.dispatchEvent(event);
      });

      scope.$on('$destroy', function() {

        Object.keys(rootWatchers)
          .forEach(function(killWatcherKey) {

            rootWatchers[killWatcherKey]();
          });
      });
    }
  };
}

export default PersistentVideoDirective;



// WEBPACK FOOTER //
// ./app/components/nn-persistent-video/nn-persistent-video.directive.js